import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import IntlMessage from '../../../../../../helpers/intlMessage';

function Padrao ({ lista }) {
  const headerListItens = [
    <IntlMessage id = "dashboards.disposalMaterials.items"/>,
    <IntlMessage id = "dashboards.disposalMaterials.user"/>,
    <IntlMessage id = "dashboards.disposalMaterials.description"/>,
    <IntlMessage id = "dashboards.disposalMaterials.totalWeight"/>,
    <IntlMessage id = "dashboards.disposalMaterials.discardDate"/>
  ];

  return (
    <TableReport
      title={<IntlMessage id = "dashboards.disposalMaterials.discardedReports"/>}
      assinatura={<IntlMessage id = "dashboards.disposalMaterials.signatureCRM"/>}
      headerList={headerListItens}
    >
      {lista.map((item, i) => (
        <tr key={i}>
          <td>{item.items}</td>
          <td>{item.usuarioLiberacao}</td>
          <td>{item.descricaoLote}</td>
          <td>{item.pesoTotal}</td>
          <td>{item.dataDescarte}</td>
        </tr>
      ))}
    </TableReport>
  );
}

Padrao.propTypes = {
  lista: PropTypes.array.isRequired
};

Padrao.defaultProps = {
  lista: []
};

export default Padrao;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/Lote/Padrao/index.js